import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'iad-redirect',
  templateUrl: './redirect.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RedirectComponent {}
